import React from 'react'
import { iconMap } from '../../../assets/icons/guardia/iconMap'
import { toSentenceCase } from '../../../utils/stringsUtils'
import { Card, CardLabel, Container, Grid, IconWrapper, Subtitle, Title } from './styled'

const Speciality = ({ specialities, saveSpeciality }) => {
  
  return (
    <Container>
      <Title>Ingresá a la fila de la guardia</Title>
      <Subtitle>¿Qué especialidad necesitás consultar?</Subtitle>
      <Grid>
        {specialities.map(({ idEspecialidad, nombre }) => (
          <Card key={idEspecialidad} onClick={() => saveSpeciality({ id: idEspecialidad, name: nombre })}>
            <IconWrapper>
              <img
                src={iconMap[idEspecialidad] || iconMap['default']}
                alt={nombre}
              />
            </IconWrapper>
            <CardLabel>{toSentenceCase(nombre)}</CardLabel>
          </Card>
        ))}
      </Grid>
    </Container>
  )
}

export default Speciality
